var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['zg-form-element', {
    'zg-form-element--hidden': _vm.hidden,
    'zg-form-element--no-margin': _vm.noMargin,
    'zg-form-element--auto-width': _vm.autoWidth,
    'zg-form-element--full-width': _vm.fullWidth,
  }]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }